import { coreDealApi } from '@cp/entities/deal';

export const adminDealApi = coreDealApi.enhanceEndpoints({
  endpoints: {
    getOne: {
      query: ({ dealId }) => `admin/deals/${dealId}`,
    },
  },
});
